import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_60aa85z7bz: FaireBrandEntity = {
  token: "b_60aa85z7bz",
  type: "brand",
  name: "Painted Lavender",
  avatarUrl:
    "https://cdn.faire.com/fastly/27ae434b636b68413893bc3679f34bfb1f579dfd96c7103672a6df1e37a68cb0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/14aa84a4b96f3cbf689b9fa54eaf59c364616f4b6a962107fb8795049f509587.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/27ae434b636b68413893bc3679f34bfb1f579dfd96c7103672a6df1e37a68cb0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14aa84a4b96f3cbf689b9fa54eaf59c364616f4b6a962107fb8795049f509587.jpeg",
  location: "Mountain House, CA, USA",
  minimumOrderDollars: 138,
  rating: 5,
  reviewCount: 37,
  isTopShop: true,
  isInsider: true,
  description:
    "Thank you for your interest in Painted Lavender!  We are a small, woman-owned business, creating cute and comfy apparel, stickers and accessories.  We offer a variety of on-trend and minimalistic designs - mostly exclusive to our brand - that are uplifting, encouraging and sure to spark joy with your customers.  Everything in our wholesale collection is made to order with the utmost care, sourcing only quality materials that result in products you will be  proud to carry in your shop. \n\nThe majority of our products are printed, packaged and shipped with love from Northern California.  We can't wait to work with you!",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:35:48.660Z",
    importedBy: "entity-db-cli",
  },
};
